import React from 'react';
import { Link } from 'react-router-dom';

/*
  Wave G-A · Compact in-app footer.
  Mounts inside MainLayout at the bottom of the scroll area on every
  authenticated page. Subtle by design — small links, navy-soft colour,
  hairline rule, single line of company entity. Marketing/public pages
  keep their richer Footer in LandingPage / LegalPageShell.

  Wave 1 fix sprint (2026-02): each link now wraps in a min-h-[44px]
  inline-flex with extra horizontal padding so the tap target meets
  Apple HIG 44×44 minimum. Visual size stays small; click area extends
  invisibly around the visible text.
*/
const linkClass =
  'inline-flex items-center min-h-[44px] px-2 text-slate-500 hover:text-slate-800 transition-colors';

export const CompactFooter = () => (
  <footer
    className="mt-10 pt-3 pb-2 border-t border-[#ECE8E1]"
    data-testid="app-compact-footer"
  >
    <div className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0 font-sans text-[11.5px]">
      <Link
        to="/privacy"
        className={linkClass}
        data-testid="footer-link-privacy"
      >
        Privacy
      </Link>
      <span className="text-slate-300" aria-hidden>·</span>
      <Link
        to="/terms"
        className={linkClass}
        data-testid="footer-link-terms"
      >
        Terms
      </Link>
      <span className="text-slate-300" aria-hidden>·</span>
      <Link
        to="/security"
        className={linkClass}
        data-testid="footer-link-security"
      >
        Security
      </Link>
      <span className="text-slate-300" aria-hidden>·</span>
      <Link
        to="/medical-disclaimer"
        className={linkClass}
        data-testid="footer-link-medical"
      >
        Medical
      </Link>
      <span className="text-slate-300" aria-hidden>·</span>
      <Link
        to="/contact"
        className={linkClass}
        data-testid="footer-link-contact"
      >
        Contact
      </Link>
    </div>
    <p
      className="mt-1 text-center font-sans text-[10.5px] text-slate-400"
      data-testid="footer-entity-compact"
    >
      © 2026 Kindra AI Pty Ltd · Brisbane, Australia
    </p>
  </footer>
);

export default CompactFooter;
